// Tim Hortons has a special super hero header,
// This makes sure that we do not actually render a super header on other
// brands/platforms

import { IHeroSuperText } from './types';

export const HeroSuperText: React.FC<IHeroSuperText> = () => null;
